import OpenInNewOutlinedIcon from '@mui/icons-material/OpenInNewOutlined'

import PageWrapper from '/components/page-wrapper'
import logo from '/assets/images/smartix-logo.png'

import HelpText from '/help/login'
import SmartixSignIn from '/components/login/signin-form'

const LoginForm = () => {

  return (
    <PageWrapper title="Login" HelpText={HelpText}>
      <div className='overflow-y-scroll w-full h-full'>
        <div className="login-hero flex flex-col gap-12 xl:flex-row w-full justify-between items-center xl:items-start pt-16 px-6 xl:px-16">

          <div className='login-hero__brand flex flex-col gap-6 items-center text-center xl:text-left xl:items-start'>
            <div className='login-hero__logo-row flex flex-col gap-6 items-center sm:flex-row'>
              <img src={logo} className="login-hero__logo" />

              <div className='flex flex-col items-center xl:items-start'>
                <div className='smartix home'>SMARTIX</div>
                <div className='studio home'>Studio</div>
              </div>

            </div>

            <div className='tagline text-center w-full'>Bridging the gap between you and your customers.</div>

            <div className="m-20 mt-10 text-2xl opacity-70 max-w-[500px]">
              <div>Smartix powers enhanced custoner engagement using digital wallet passes for Apple and Google Wallet. If you’re new here, head to our website to see how it works.</div>
              <div className='mt-5'><a href="https://www.smartix.uk" target='_blank' className='link' rel="noreferrer">Discover Smartix<OpenInNewOutlinedIcon className='ml-2' /></a></div>
            </div>

          </div>

          <div className="flex items-start justify-center signin-override max-w-xl xl:max-w-none">
            <SmartixSignIn />
          </div>

        </div>
      </div>
    </PageWrapper>
  )
}

export default LoginForm
